var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "v-dialog",
        { attrs: { "max-width": "1000px", persistent: "", value: true } },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(_vm._s(_vm.$t("global.insurance")))
                ])
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      attrs: { "lazy-validation": "" },
                      model: {
                        value: _vm.formValid,
                        callback: function($$v) {
                          _vm.formValid = $$v
                        },
                        expression: "formValid"
                      }
                    },
                    [
                      _c("multiple-user-select", {
                        attrs: { "birth-date-required": true }
                      }),
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("location-ajax-select", {
                                attrs: {
                                  label: _vm.$t("travelService.place") + "*",
                                  placeholder: _vm.$t(
                                    "travelService.enterCountry"
                                  ),
                                  rules: [
                                    function(v) {
                                      return (
                                        (v != null && v.length > 0) ||
                                        _vm.$t("global.error.required")
                                      )
                                    }
                                  ],
                                  "select-model":
                                    _vm.contextModel
                                      .travelServiceOrderItemInsurance.place_id
                                },
                                on: {
                                  "update:selectModel": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemInsurance,
                                      "place_id",
                                      $event
                                    )
                                  },
                                  "update:select-model": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemInsurance,
                                      "place_id",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { staticClass: "pr-2", attrs: { cols: "6" } },
                            [
                              _c("date-picker", {
                                attrs: {
                                  label: _vm.$t("global.startDate") + "*",
                                  max:
                                    _vm.contextModel
                                      .travelServiceOrderItemInsurance.end_date,
                                  model:
                                    _vm.contextModel
                                      .travelServiceOrderItemInsurance
                                      .start_date,
                                  rules: [
                                    _vm.validatorIsRequired,
                                    _vm.validatorIsFutureDate
                                  ]
                                },
                                on: {
                                  "update:model": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemInsurance,
                                      "start_date",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pl-2", attrs: { cols: "6" } },
                            [
                              _c("date-picker", {
                                attrs: {
                                  label: _vm.$t("global.endDate") + "*",
                                  min:
                                    _vm.contextModel
                                      .travelServiceOrderItemInsurance
                                      .start_date,
                                  model:
                                    _vm.contextModel
                                      .travelServiceOrderItemInsurance.end_date,
                                  rules: [
                                    _vm.validatorIsRequired,
                                    _vm.validatorIsFutureDate
                                  ]
                                },
                                on: {
                                  "update:model": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemInsurance,
                                      "end_date",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("cost-centre-select", {
                                attrs: { value: _vm.contextModel.cost_centre },
                                on: {
                                  "update:value": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel,
                                      "cost_centre",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-text-field", {
                        attrs: { label: _vm.$t("global.comment") },
                        model: {
                          value: _vm.contextModel.comment,
                          callback: function($$v) {
                            _vm.$set(_vm.contextModel, "comment", $$v)
                          },
                          expression: "contextModel.comment"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.cancel($event)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled: !_vm.formValid,
                        color: "blue darken-1",
                        text: ""
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.save($event)
                        }
                      }
                    },
                    [_vm._v("Ok")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }